export default {
    name: 'app-sidebar-element',
    props: ['marker'],

    data() {
        return {
            thumbnail: require('../../assets/images/vignettes/' + this.marker.thumbnail)
        }
    }
}